import { setNestedField } from './setNestedField'

export const mergeNestedFields = (target: object, source: object) => {
  return Object.keys(source).reduce((accumulator, key) => {
    return setNestedField(key, source[key], accumulator)
  }, target)
}
